import "../top.css";
import "../commoncss/link.css";
import "../commoncss/pc_menu_top.css";
import "../commoncss/loading.css";
import {getDevice} from "../commonjs/device.js";  
import {google} from "../commonjs/google.js";
import {load_off} from "../commonjs/load.js";

import "@babel/polyfill";//promise　やarrayfromも変換


window.onload = function(){
    load_off();
    google();
    const wall01 = document.getElementById(`wall01`);
    const wall02 = document.getElementById(`wall02`);
    const wall03 = document.getElementById(`wall03`);
    
    const h3 = document.getElementsByTagName(`h3`)[0];
    const statement = document.getElementById(`statement`);
    
    const nav = document.getElementsByTagName(`nav`);
    const mobile = document.getElementById(`mobile`);
    const mobile_menu = document.getElementById(`mobile_menu`);
    const mobile_close = document.getElementById(`mobile_close`);
    const device = getDevice();
    
    /*==========mobile======================*/
    mobile_menu.addEventListener(`click`,fadein_nav);
    
    function fade_out(elm,speed){
        if(speed === undefined){
                    speed = 1000;
                }
        const present = document.defaultView.getComputedStyle(elm,null).left;
        
        elm.animate({opacity:[present,0]},{
            direction: `alternate`,
            duration: speed,
            fill:`forwards`,
        });
    }
    
    function fadein_nav(e){
        console.log("done");
        nav[0].style.display = `block`;
        nav[0].animate({
            opacity: [0,0.8]
        },{
            direction: `alternate`,
            duration: 1000,
            fill:`forwards`,
        });
        
        mobile_menu.animate([{transform:`scale(1)`},{
            transform:`scale(1.5)`
        }],{
            direction:`alternate`,
            duration: 1000,
            fill:`forwards`,                
        });
        
        const fade_out = mobile_menu.animate({opacity:[1,0]},{
            direction: `alternate`,
            duration: 1000,
            fill:`forwards`,
        });
        
        fade_out.addEventListener(`finish`,()=>{
            mobile_menu.style.display = `none`;
            mobile_close.style.display = `block`;
            mobile_close.animate({opacity:[0,1]},{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            mobile_close.animate([{transform:`scale(1.5)`},{
                transform:`scale(1)`
            }],{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            
        });
        mobile_close.addEventListener(`touchstart`,fadeout_nav);
        mobile_menu.removeEventListener(`touchstart`,fadein_nav);
    }
    
    
    
    
    function fadeout_nav(e){
         const fadeout = nav[0].animate({opacity:[1,0]},{
            direction: `alternate`,
            duration: 1000,
            fill:`forwards`,
        });
        
        fadeout.addEventListener(`finish`,()=>{
            nav[0].style.display = `none`;
            mobile_close.style.display = `none`;
            mobile_menu.style.display = `block`;
            mobile_menu.animate({opacity:[0,1]},{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            
            mobile_menu.animate([{transform:`scale(1.5)`},{
                transform:`scale(1)`
            }],{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
        });
        
        mobile_close.animate({opacity:[1,0]},{
            direction: `alternate`,
            duration: 1000,
            fill:`forwards`,
        });
        
        mobile_close.animate([{transform:`scale(1)`},{
            transform: `scale(1.5)`
        }],{
            direction: `alternate`,
            duration: 1000,
            fill:`forwards`,
        });
        mobile_close.removeEventListener(`touchstart`,fadeout);
        mobile_menu.addEventListener(`touchstart`,fadein_nav);
    }
    /*========================================*/
    
    
    
    
    
    
    
    class Moving_image {
        constructor(elm,movetime,distance,delay){
            this.elm = elm;
            this.movetime = movetime;
            this.distance = distance;
            this.delay = delay;
        }
        
        fadein(){
            this.elm.animate({
                opacity: [0,1]
            },{
                direction:`alternate`,
                duration: 2000,
                fill: `forwards`,
                delay:this.delay,
            });
        }
        
        slow_move_left(){
            this.elm.animate({
                left: [0,this.distance]
            },{
                direction:`alternate`,
                duration: this.movetime,
                fill: `forwards`,
                delay:this.delay,
            });
        }
        
        slow_move_top(){
            this.elm.animate({
                top: [0,this.distance]
            },{
                direction:`alternate`,
                duration: this.movetime,
                fill: `forwards`,
                delay:this.delay,
            });
        }
        
        undo(){
            const trans = parseFloat(document.defaultView.getComputedStyle(this.elm).opacity);
            const back_black = this.elm.animate({
                opcity: [trans,0]
            },{
                direction:`alternate`,
                duration: 1000,
                fill: `forwards`,
            });
            
            back_black.addEventListener(`finish`,()=>{
               const point = parseFloat(document.defaultView.getComputedStyle(this.elm).left); 
               this.elm.animate({
                   left: [point,0]
               },{
                    direction:`alternate`,
                    duration: 10,
                    fill: `forwards`,
               }); 
            });
        }
    }
    const landscape = new Moving_image(wall01,10000,`-20%`,0);
    const alone = new Moving_image(wall02,10000,`-20%`,0);
    const float = new Moving_image(wall03,8000,`0`,0);
    
    window.addEventListener(`scroll`,launch_moving);
    
    function launch_moving(){
        console.log(window.pageYOffset);
        let scroll_point = 960;
        
        if(device === `device`){
            scroll_point = 700;
        }
        
        
        if(window.pageYOffset>scroll_point){
            
            removeEventListener(`scroll`,launch_moving);
            const first = () => {
                return new Promise(resolve =>{
                    setTimeout(()=>{
                        
                        landscape.fadein();
                        landscape.slow_move_left();
                        resolve();
                    },500);
                });
            }
            
            const second = () =>{
                return new Promise(resolve =>{
                    setTimeout(()=>{
                        alone.fadein();
                        alone.slow_move_top();
                        resolve();
                    },8000);
                })
            }
            
            const third = () =>{
                return new Promise(resolve =>{
                    setTimeout(()=>{
                        float.fadein();
                        resolve();
                    },5000);
                });
            }
            
            const finish = () =>{
                return new Promise(resolve =>{
                            [h3,statement].forEach(v=>{
                                v.animate({opacity:[0,1]},{
                                    direction:`alternate`,
                                    duration: 3000,
                                    fill: `forwards`,
                                });
                            });
                });
            }
            
            first()
            .then(second)
            .then(third)
            .then(finish);
            
            [h3,statement].forEach(v=>{
                v.animate({opacity:[0.5,0]},{
                    direction:`alternate`,
                    duration: 5000,
                    fill: `forwards`,
                });
            });
        }
               
    }
    
                            
}